import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {acquireAccessToken} from './ApiService';
import {msalInstance} from 'index';
import {Project, ReportToken} from 'core/slices/models';

// Custom baseQuery to safely perform async token acquisition BEFORE invoking fetchBaseQuery
const rawBaseQuery = fetchBaseQuery({
  baseUrl: '/api/v1',
});

const authBaseQuery: typeof rawBaseQuery = async (args, api, extraOptions) => {
  let headers: Headers | undefined;
  let modifiedArgs = args as any;
  try {
    const token = await acquireAccessToken(msalInstance);
    if (typeof args === 'string') {
      modifiedArgs = { url: args };
    }
    headers = new Headers((modifiedArgs.headers as any) || undefined);
    if (token) headers.set('Authorization', `Bearer ${token}`);
    headers.set('Accept', 'application/json');
    modifiedArgs.headers = headers;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Token acquisition failed, proceeding without auth header', err);
  }
  return rawBaseQuery(modifiedArgs, api, extraOptions);
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: authBaseQuery,
  tagTypes: ['Token', 'Project', 'ProjectHierarchy', 'ProjectList'],
  endpoints: builder => ({
    getToken: builder.query<
      ReportToken,
      { projectKey: string; reportId: string }
    >({
      query: ({ projectKey, reportId }) => ({
        url: `projects/${projectKey}/reports/${reportId}/token`,
        method: 'POST',
      }),
      providesTags: ['Token'],
    }),

    getProjects: builder.query<Project[], void>({
      query: () => 'projects',
      providesTags: result => {
        if (!result) return ['ProjectList'];
        return [
          'ProjectList',
          ...result.map(p => ({ type: 'Project' as const, id: p.key })),
        ];
      },
    }),



  }),
});

export const {
  useGetProjectsQuery,
} = apiSlice;
